import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "message-success",
  "use": "message-success-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"message-success\">\n    <path fill=\"#4dc749\" d=\"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm4.95 7.464l-7.071 7.072-2.829-2.829-1.414 1.414 4.243 4.243 8.485-8.485-1.414-1.415z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol